import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';
import styled, { css } from 'styled-components/macro';

interface Props {
    color: string;
    text?: string;
    icon?: {
        iconPrefix: IconPrefix;
        iconName: IconName;
    };
    width: number;
    fontSize: number;
    disabled?: boolean;
    className?: string;
    style?: CSSProperties;
    onMouseUp?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    onMouseDown?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const Point = (props: Props): JSX.Element => {
    return (
        <div
            style={props.style}
            className={props.className}
            onMouseDown={props.onMouseDown}
            onMouseUp={props.onMouseUp}
        >
            <div>
                <S_Border $width={props.width} $disabled={props.disabled}>
                    <S_Fill
                        $color={props.color}
                        $fontSize={props.fontSize}
                        $disabled={props.disabled}
                    >
                        {props.icon && (
                            <S_Icon
                                icon={[props.icon.iconPrefix, props.icon.iconName]}
                                $fontSize={props.fontSize}
                            />
                        )}{' '}
                        {props.text}
                    </S_Fill>
                </S_Border>
            </div>
        </div>
    );
};

const S_Border = styled.div<{ $width: number; $disabled: boolean }>`
    height: ${(props) => props.$width}px;
    width: ${(props) => props.$width}px;
    background: #fff;
    position: absolute;
    left: -${(props) => props.$width / 2}px;
    top: -${(props) => props.$width / 2}px;
    border-radius: 50%;
    border: 1px solid #ccc;
    z-index: 1;
    cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
    ${(props) => {
        if (!props.$disabled) {
            return css`
                &:hover {
                    height: ${() => props.$width + 4}px;
                    width: ${() => props.$width + 4}px;
                    left: -${() => (props.$width + 4) / 2}px;
                    top: -${() => (props.$width + 4) / 2}px;
                }
            `;
        }
    }}

    user-select: none;
`;

const S_Fill = styled.div<{ $color: string; $fontSize: number; $disabled: boolean }>`
    background-color: ${(props) => props.$color};
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${(props) => props.$fontSize}px;
    z-index: 2;
    color: #000;
    cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
    user-select: none;
`;

const S_Icon = styled(FontAwesomeIcon)<{ $fontSize: number }>`
    font-size: ${(props) => props.$fontSize}px;
    width: 14px;
    user-select: none;
`;
